import { useRef } from 'react';
import produce from 'immer';
import { Attachment } from '../types';
import { OnDragEndResult } from '../../../DragSortListWrap';
import { reOrderArray } from '../../../../lib/common';

const useAttachmentListState = (value: Attachment[], onChange?: (attachmentList: Attachment[]) => void) => {
  const attachmentList = useRef(value);
  attachmentList.current = value;

  const uploadSuccessAttachment = (data: Attachment, index: number) => {
    const newList = produce(attachmentList.current, (draft) => {
      draft[index] = {
        url: data.url,
        width: data.width,
        height: data.height,
        type: data.type,
      };
    });

    attachmentList.current = newList;
    if (!onChange) return;
    onChange(newList);
  };
  const changeOrderAttachment = (result: OnDragEndResult) => {
    if (!result.destination) return;
    const newList = reOrderArray(attachmentList.current, result.source.index, result.destination.index);

    attachmentList.current = newList;
    if (!onChange) return;
    onChange(newList);
  };

  const deleteAttachment = (index: number) => {
    const newList = attachmentList.current.filter((_, _index) => _index !== index);
    attachmentList.current = newList;
    if (!onChange) return;
    onChange(newList);
  };

  return { uploadSuccessAttachment, changeOrderAttachment, deleteAttachment };
};

export default useAttachmentListState;
